import { render, staticRenderFns } from "./role-changed.vue?vue&type=template&id=629089d2"
import script from "./role-changed.vue?vue&type=script&lang=js"
export * from "./role-changed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports